/**
 * Captures where a visitor came from, once per browser session.
 *
 * document.referrer is only populated on the first page load, and the signup
 * form is usually not that page, so this records on arrival and reads back at
 * registration. sessionStorage rather than localStorage so a returning visitor
 * is attributed to their current visit, not their first ever one.
 */

const KEY = "joborigo-signup-source";

export function captureSignupSource() {
  try {
    // Only the first page of the session counts as the landing page
    if (sessionStorage.getItem(KEY)) return;

    const ref = document.referrer || "";
    // Internal navigation is not a referrer worth recording
    const isInternal = ref && new URL(ref).host === window.location.host;

    sessionStorage.setItem(
      KEY,
      JSON.stringify({
        referrer: isInternal ? "" : ref.slice(0, 500),
        landing_path: (window.location.pathname + window.location.search).slice(0, 500),
      })
    );
  } catch {
    // Private browsing or a malformed referrer. Attribution is a nice to have,
    // never a reason to break the page.
  }
}

/** Returns { signup_referrer, signup_landing_path } for the register payload. */
export function getSignupSource() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return {};
    const { referrer, landing_path } = JSON.parse(raw);
    return {
      signup_referrer: referrer || null,
      signup_landing_path: landing_path || null,
    };
  } catch {
    return {};
  }
}
